import { css } from "@emotion/css";

type StyleValue = string | number | Record<string, any>;
type StylesObject = Record<string, Record<string, StyleValue>>;

export function makeStyles() {
  return function <T extends StylesObject>(
    stylesOrCreator: T | ((theme?: any) => T)
  ) {
    return function (): { classes: { [K in keyof T]: string } } {
      const styles =
        typeof stylesOrCreator === "function"
          ? stylesOrCreator()
          : stylesOrCreator;
      const classes = Object.fromEntries(
        Object.entries(styles).map(([key, value]) => [key, css(value as any)])
      ) as { [K in keyof T]: string };
      return { classes };
    };
  };
}
